import React, { Component } from 'react';
import { size, map, filter, isEmpty, has } from 'lodash';

import { Dropdown, DropdownToggle, DropdownMenu, DropdownItem, Button } from 'reactstrap';

// FA icons list
import {FontAwesomeIcon as FA} from '@fortawesome/react-fontawesome';
import faTrashAlt from '@fortawesome/fontawesome-pro-light/faTrashAlt';
import faTimes from '@fortawesome/fontawesome-pro-light/faTimes';
import faIconsListRaw from '../helpers/faIconsList';

import { fab } from '@fortawesome/free-brands-svg-icons';
import { fas } from '@fortawesome/free-solid-svg-icons';
import { far } from '@fortawesome/free-regular-svg-icons';
import { library } from '@fortawesome/fontawesome-svg-core';

library.add(fab, fas, far);



const faIconsList = filter(faIconsListRaw, (icon)=>{
  return has(library.definitions, icon.title.replace("fa-", "").replace(" ", "."))
})

class IconPickerAdapter extends Component {

  constructor(props) {
    super(props);
    
    this.toggle = this.toggle.bind(this);
    this.filterText = this.filterText.bind(this);
    this.handleChange = this.handleChange.bind(this);
    
    const { dropdownOpen, filterText } = this.props;
    this.gaSearchTrackerTimeout = null
    this.state = {
      dropdownOpen,
      filterText: filterText || ""
    };
  }
  
  componentWillReceiveProps (nextProps){
    if (nextProps.children !== this.props.children){
      const options = map(filter(nextProps.children, {type: 'option'}), (o)=> o.props)
      this.setState({
        options
      });
    }
  }
  
  toggle() {
    this.setState({
      dropdownOpen: !this.state.dropdownOpen
    });
  }
  
  handleChange(value){
    const { input } = this.props;
    return () => {
      input.onChange(value);
      this.setState({filterText: "", dropdownOpen: false})
    }
  }
  
  filterText (e){
    const filterText = e.target.value || ''
    this.setState({filterText: filterText.replace(/^\s+|\s+$/g, '')})
    
    if (this.gaSearchTrackerTimeout)
      clearTimeout(this.gaSearchTrackerTimeout)
    
    this.gaSearchTrackerTimeout = setTimeout(() => {
      if (window.dataLayer){
        window.dataLayer.push({event: 'SEARCH', query: filterText, cat: 'bio_icons'})
      }
    }, 1000)
  }
  
  filterList (filterText){
    var regex = false;
    try {
      regex = new RegExp('(^|\\W)' + filterText.replace(' ', '(\\s|-)'), 'gi');
    } catch (e) {
      regex = false;
    }
    
    if (isEmpty(filterText)) {
      return faIconsList
    } else {
      return filter(faIconsList, (icon) => {
        const { title, searchTerms } = icon;
        const query = title.replace(/^fa(r|s|b) /g, '') + ' ' + searchTerms.join(' ');
        return query.match(regex)
      });
    }
  }
  
  
  render () {
    const { input, className, disabled } = this.props;
    const { filterText } = this.state;
    const button = isEmpty(input.value) ? <span className="small">No Icon</span> : <FA icon={input.value.replace("fa-", "").split(" ")} className="fa-icon" />
    
    const filteredOptions = this.filterList(filterText || "whatsapp|itunes|soundcloud|spotify|facebook|patreon|behance|instagram|kickstarter|medium|pinterest|producthunt|slack|tiktok|twitch|tripadvisor|yelp|vimeo")
    
    return (
      <Dropdown className={(className || "") + " icon-picker-dropdown"} isOpen={this.state.dropdownOpen} toggle={this.toggle}>
        <DropdownToggle caret className="btn-outline-border" disabled={disabled}>
          { button } 
        </DropdownToggle>
        <DropdownMenu>
          <div className="dropdown-filter search-row">
            <input type="text" className="form-control form-control-sm" placeholder={`Find in ${size(faIconsList)} icons`} value={filterText} onChange={this.filterText} />
            <span className="btn-add-pixel-badge close-btn" title="Close" onClick={this.toggle}><FA icon={faTimes} /></span>
          </div>
          <div className="dropdown-scrolled-items">
            {filteredOptions && size(filteredOptions) > 0 ? map(filteredOptions, (option, idx) => {
              return option && option.title && <DropdownItem key={idx} onClick={this.handleChange(option.title)}><FA icon={option.title.replace("fa-", "").split(" ")} /></DropdownItem>
            }) : <div className="text-center items-empty">No icons found</div>}
          </div>
          {!isEmpty(input.value) && <div className="dropdown-filter text-center">
            <Button onClick={this.handleChange("")} color="link" size="sm"><FA icon={faTrashAlt} /> remove icon</Button>
          </div>}
        </DropdownMenu>
      </Dropdown>);
  }
};

export default IconPickerAdapter;


// WEBPACK FOOTER //
// ./src/components/helpers/IconPickerAdapter.js